import {
    HttpClient,

    HttpHeaders
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { v4 as uuid } from 'uuid';
import { ItemMaster } from '../model/item';

export interface lookupCode {
    lookupCode: string;
    lookupCodeDescription: string;
}

export class lookup {
    lookupName: string;
    lookupDescription: string;
    lookupCodes: lookupCode[];
}

export class responseFormat {
    lookups: lookup[];
    requestIdentifier: string;
    success: boolean;
    transactionDate: string;
}


@Injectable({
    providedIn: 'root'
})

export class ApiService {

    constructor(
        private http: HttpClient
    ) { }


    public getItem(url: string, params): Observable<lookupCode[]> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            // Authorization: 'Basic ' + btoa('PPPPortal:Fedex@123'),
            APPID: environment.apiBussServAPPID,
            UUID: uuid(),
            'Access-Control-Allow-Origin': '*'
        });

        if (!url) {
            return;
        }

        return this.http.get<responseFormat>(url, { headers, params: params })
            .pipe(map((response: responseFormat) => (response.lookups[0].lookupCodes as lookupCode[])));
    }

    public getItemByID(url: string, params): Observable<ItemMaster> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            // Authorization: 'Basic ' + btoa('PPPPortal:Fedex@123'),
            APPID: environment.apiBussServAPPID,
            UUID: uuid(),
            'Access-Control-Allow-Origin': '*'
        });

        if (!url) {
            return;
        }

        return this.http.get(url, { headers, params: params }).pipe(map((response: ItemMaster) => response))
    }
};